const t={light:"#1D7AFC",dark:"#1D7AFC"};export{t as PAGE_ACCENT_COLOR};
